// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";

export const buscarEmpreedService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/empreendimento/`;
    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const empreendimentosArray = response.data.map((empreendimento: any) => {
        return {
          key: empreendimento.id,
          empreendimento: empreendimento.nome,
          cidadeId: empreendimento.cidadeId,
          contato: empreendimento.contato,
          cronograma: empreendimento.cronograma,
          origem: empreendimento.origem === 0 ? "Multicotas" : "Usuário",
          descricao: empreendimento.descricao,
        };
      });

      return empreendimentosArray;
    } catch (error) {
      console.error(error);
    }
  }
};
